import React, {FC, useState} from 'react'
import classnames from 'classnames'
import {Link} from 'react-router-dom'
import {RenderIf} from 'components/Basic'
import {useSelector} from 'react-redux'
import {selectPolicies} from 'features/Policies/policiesSelectors'
import {Policy} from 'interfaces'
import {usePoliciesList} from 'features/Policies/usePolicyQuery'

interface LinkProps {
  pathname: string
  linkName: string
  current: boolean
  first?: boolean
  last?: boolean
  count?: number
  classNames?: string
  children?: React.ReactNode
  currentPolicyName?: string
  isVisible?: boolean
}

const pathWithState = ['content', 'bypass', 'users', 'cloudapp', 'dlp']

export const NavLink: FC<LinkProps> = ({
  pathname,
  current,
  linkName,
  children,
  classNames = '',
  currentPolicyName,
  isVisible = true,
}) => {
  const [hover, setHover] = useState<boolean>(false)
  const {selectedPolicyName} = useSelector(selectPolicies)

  // Not used useQuery/useInfiniteQuery here, as using policy list from cache is enough here
  const policies = usePoliciesList()

  const _to = (() => {
    if (pathWithState.includes(pathname.split('/')[2].toLowerCase())) {
      return {pathname, state: {policyName: currentPolicyName}}
    } else return pathname
  })()

  const getBackgroundColor = () => {
    if (hover) return 'border-white'
    else if (
      policies &&
      policies?.length > 1 &&
      selectedPolicyName?.match(Policy.BasePolicy) &&
      pathname.includes('/policies')
    )
      return 'border-dope-teal-100'
    else return 'border-transparent'
  }

  return (
    <RenderIf isTrue={isVisible}>
      <div className={classnames(`group flex items-center ${classNames} h-12`)}>
        <Link
          to={_to}
          data-cy={pathname.replaceAll('/', '')}
          aria-label={`${linkName} Tab`}
        >
          <div
            className={classnames(`group flex flex-col ${classNames}`)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {children}
            <span
              className={classnames(
                `leading-snug text-white text-2xl abc-exl`,
                {
                  'abc-regular -mt-2': current,
                },
              )}
            >
              {linkName}
            </span>
            <RenderIf isTrue={!current}>
              <div
                className={classnames(
                  'w-10 border-b-3 -mt-2',
                  getBackgroundColor(),
                )}
              />
            </RenderIf>
          </div>
          <RenderIf isTrue={current}>
            <div className="w-10 border-b-3 border-white -mt-1" />
          </RenderIf>
        </Link>
      </div>
    </RenderIf>
  )
}
